import React from 'react';

import '../style.css';
import CONF from '../Conf';
import LikeButton from '../Buttons/Like';
import ShareButton from '../Buttons/Share';

export default function SolutionCard({
  language,
  body,
  fontColor,
  component,
  iconTitleColor,
  iconTitle,
  iconUrl,
  abTest,
}) {
  return (
    <article className='Solution Card' language={language} id={abTest}>
      <header>
        {CONF.iconFromComponent(component, CONF.solutionTipIconColor(iconTitleColor))}
        <h1 style={{ color: 'var(--awGray7)' }}>{iconTitle}</h1>
      </header>
      <section style={{ color: CONF.color(fontColor) }}>
        <p>{body}</p>
      </section>
      <footer>
        <LikeButton />
        <ShareButton />
      </footer>
    </article>
  );
}
